import PropTypes from 'prop-types';
import styled from 'styled-components';
import { borderRadius, color, fontSize, space } from '@ifixit/primitives';
import { Button, Flex, Image, Link } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';

const propTypes = {
   title: PropTypes.string.isRequired,
   description: PropTypes.string,
   imageUrl: PropTypes.string,
   editUrl: PropTypes.string.isRequired,
   isOrphan: PropTypes.bool,
   onChangeClick: PropTypes.func,
};

const Container = styled.div({
   border: `1px solid ${color.gray[300]}`,
   borderRadius: borderRadius.md,
   overflow: 'hidden',
});

const Title = styled.span({
   padding: `${space[0]} ${space[2]}`,
   fontSize: fontSize['2xl'],
   fontWeight: 'bold',
   color: color.gray[900],
   lineHeight: 'inherit',
});

const Description = styled.p({
   lineHeight: 'inherit',
   fontSize: fontSize.md,
   margin: `${space[1]} 0`,
   padding: `0 ${space[2]}`,
   color: color.gray[600],
});

const Warning = styled.div({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'space-between',
   backgroundColor: color.yellow[100],
   padding: `${space[1]} ${space[3]}`,
});

const WarningText = styled.span({
   padding: `${space[1]} ${space[2]}`,
   color: color.gray[900],
   fontSize: fontSize.md,
   lineHeight: 'inherit',
});

const InfoContainer = styled.div`
   width: 100%;
   flex: 1 1 auto;
`;

const TitleContainer = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: flex-start;
`;

function DevicePreview({
   title,
   description = '',
   imageUrl = '',
   editUrl,
   isOrphan = false,
   onChangeClick = () => {},
}) {
   return (
      <Container>
         <Flex padding={space[3]} align="center" direction={{ base: 'column', sm: 'row' }}>
            {imageUrl !== '' && (
               <Image
                  src={imageUrl}
                  flex="0 0 auto"
                  maxW="96px"
                  mb={{ base: 0, sm: space[2] }}
                  borderRadius={borderRadius.sm}
                  mr={{ sm: space[2] }}
               />
            )}
            <InfoContainer>
               <TitleContainer>
                  <Title>{title}</Title>
                  <Button
                     id="chooseAskDeviceButton"
                     size="sm"
                     onClick={e => {
                        e.currentTarget.blur();
                        onChangeClick();
                        e.preventDefault();
                     }}
                  >
                     {_js('Change')}
                  </Button>
               </TitleContainer>
               {description !== '' && <Description>{description}</Description>}
            </InfoContainer>
         </Flex>
         {isOrphan && (
            <Warning>
               <WarningText>{_js('This device page does not exist yet.')}</WarningText>
               <Button as={Link} href={editUrl} isExternal size="sm">
                  {_js('Create Device')}
               </Button>
            </Warning>
         )}
      </Container>
   );
}

DevicePreview.propTypes = propTypes;
export default DevicePreview;
